import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import PrimeTableFooter from "../../../components/PrimeTableFooter";

import { FormInput } from "../../../components/FormInput";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Chip } from "primereact/chip";
import { Sidebar } from "primereact/sidebar";
import { useOutletContext } from "react-router";
import { ReactComponent as Avatar } from "../../../assets/images/img-avatar.svg";
import NoInfo from "../../../components/NoInfo";
import PrimeDialog from "../../../components/dialog/PrimeDialog";
import { useEditableFlag } from "../../../hooks/useEditableFlag";
import { useFuncId } from "../../../router/menuRouterMapper";
import { SystemLoading, checkLoading } from "../../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../../store/messageStore";
import { updateAuditEyesEvent } from "../../../utility/service/audilog-service";
import { SubAcctInviteRecords } from "../../../utility/service/invite-service";
import {
  CreateInviteSubAcct,
  F2010206Before,
  createManagerAcct,
  getRoleList,
  initSubAccData,
  querySubAccData,
} from "../../../utility/service/personal-service";
import { checkDpSuccess, getAcct, getCompanyType, getMaskedString } from "../../../utility/service/tool-service";
import { addFormValidator } from "../../../utility/validate/formValidator";
import AddSubAcct from "./AddSubAcct";
import InviteSubAcct from "./InviteSubAcct";

export const SubAccountIndex = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setItemObj, setAction, currentStatus, setCurrentStatus } = useOutletContext();
  const [, loading] = useContext(SystemLoading);
  const [addDialog, setAddDialog] = useState(false);
  const [confirmLoad, setConfirmLoad] = useState(false);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [inviteDialog, setInviteDialog] = useState(false); //邀請
  const [inviteSidebar, setInviteSidebar] = useState(false);
  const [maskView, setMaskView] = useState(false);
  const chsFuncId = useFuncId();
  const isEditable = useEditableFlag("F20102"); // 取得 F20102 功能的可編輯狀態

  const {
    getValues,
    setValue,
    control,
    clearErrors,
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      roleSeq: "",
      status: "",
      keyword: "",
    },
    //錯誤驗證時機
    mode: "all",
  });
  const [rowData, setRowData] = useState([]);
  const [first, setFirst] = useState(0); // First row index of the current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  const [caseList, setCaseList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [userSeq, setUserSeq] = useState(""); //分頁用 key
  const [recordList, setRecordList] = useState([]);
  const [inviteSeq, setInviteSeq] = useState("");
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [createButtonFlag, setCreateButtonFlag] = useState(false);
  const [limitDialog, setLimitDialog] = useState(false);

  const getCurrentPageRows = () => {
    console.log(rowData?.slice(first, first + rowsPerPage));
    return rowData?.slice(first, first + rowsPerPage);
  };

  const orderNoTemplate = (data, props) => {
    return <span>{props.rowIndex + 1}</span>;
  };

  const goItemPage = (rowData, action) => {
    // console.log(rowData);
    setItemObj(rowData);
    setAction(action);
    navigate(action);
    let rowStatus = statusList?.filter((item) => item?.value === rowData?.status);
    if (rowStatus?.length > 0) {
      rowData.statusCode = rowStatus[0].label;
    }
  };

  const disabledAcct = (rowData) => {
    return rowData?.acct === getAcct();
  };

  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          {disabledAcct(rowData) ? (
            <Chip
              className="pl-1 pr-3"
              label={t("myself")}
              template={
                <>
                  <Avatar />
                  <span className="ml-2 font-medium">{t("myself")}</span>
                </>
              }
            ></Chip>
          ) : (
            <Button
              tooltipOptions={{ position: "top" }}
              tooltip={t("button.edit")}
              disabled={disabledAcct(rowData) || !isEditable}
              rounded
              text
              severity="secondary"
              className="p-button-icon-only"
              onClick={() => {
                goItemPage(rowData, "update");
              }}
            >
              <FontAwesomeIcon icon="fa-solid fa-pen" />
            </Button>
          )}

          <Button
            tooltipOptions={{ position: "top" }}
            tooltip={t("button.view")}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              goItemPage(rowData, "detail");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
        </>
      );
    }
  };

  const createDateBodyTemplate = (rowData) => {
    if (rowData) {
      return (
        <>
          <div>
            <label>{rowData?.createDateTime}</label>
          </div>
          <div>
            <label>{rowData?.createUser}</label>
          </div>
        </>
      );
    }
  };

  const onSubmit = (data) => {
    let reqBody = {
      pageSize: data.pageSize,
      pageNum: data.pageNum,
      keyword: data.keyword,
    };
    if (data.status !== "") {
      reqBody.status = data.status;
    }
    if (data.roleSeq !== "") {
      reqBody.roleSeq = data.roleSeq;
    }

    setCurrentStatus({
      roleSeq: data.roleSeq,
      status: data.status,
    });

    // axios_querySubAccData(reqBody);
  };

  const confirmInviteSubAcct = () => {
    setConfirmLoad(true);
    let reqBody = {
      userEmail: getValues("userEmail"),
      userName: getValues("userName"),
      // phone:getValues("phone"),
    };
    // 建立邀請子帳戶
    CreateInviteSubAcct(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.invite") + " " + t("message.success"));
          setInviteDialog(false);
          setValue("userEmail", "");
          setValue("userName", "");
          // setValue("phone","");
          clearErrors();
        }
      })
      .finally((fin) => {
        setConfirmLoad(false);
      });
  };

  const confirmAddSubAcct = () => {
    setConfirmLoad(true);
    let reqBody = {
      acct: `${getValues("acct")}@tpisoftware.com`,
      userName: getValues("userName"),
      // phone:getValues("phone"),
      roleSeq: getValues("add_roleSeq"),
    };
    // call 建立API
    createManagerAcct(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.create") + " " + t("message.success"));

          let reqBody = { keyword: getValues("keyword") };
          if (getValues("status") !== "") {
            reqBody.status = getValues("status");
          }
          if (getValues("roleSeq") !== "") {
            reqBody.roleSeq = getValues("roleSeq");
          }
          axios_querySubAccData(reqBody);
          setAddDialog(false);
          setValue("acct", "");
          setValue("userName", "");
          // setValue("phone","");
          setValue("add_roleSeq", "");
          clearErrors();
        }
      })
      .finally((fin) => {
        setConfirmLoad(false);
      });
  };

  const handleAddSubAcct = () => {
    setAddDialog(true);
  };

  const handleInviteSubAcct = () => {
    setInviteDialog(true);
  };

  const handleInviteSideBar = (reqBody = {}, readMore = false) => {
    setInviteSidebar(true);
    checkLoading(loading);
    SubAcctInviteRecords(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody?.inviteRecordsList;
          if (data?.length > 0) {
            setInviteSeq(data[data?.length - 1].inviteSeq);
            if (readMore === true) {
              setRecordList((pre) => {
                return [...pre, ...data];
              });
            } else {
              setRecordList(data);
            }
          } else {
            if (readMore === false) {
              setRecordList([]);
            }
          }
        } else {
          //查無資料
          if (readMore === false) {
            setRecordList([]);
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const axios_getRoleList = () => {
    getRoleList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.roleList;
        setRoleList(data);
      }
    });
  };

  const axios_querySubAccData = (reqBody = {}, readMore = false) => {
    checkLoading(loading);
    querySubAccData(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.pageDatas;
          setUserSeq(res.data.RespBody.pageDatas[res.data.RespBody.pageDatas?.length - 1].userSeq);
          setCreateButtonFlag(res.data.RespBody.createButtonFlag);
          if (readMore === true) {
            setRowData((pre) => {
              return [...pre, ...data];
            });
          } else {
            setRowData(data);
          }
        } else {
          //查無資料
          if (readMore === false) {
            setRowData([]);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => checkLoading(loading, false));
  };

  //查詢更多
  const btnReadMore = () => {
    let reqBody = {
      keyword: getValues("keyword"),
      userSeq: userSeq,
    };
    if (getValues("status") !== "") {
      reqBody.status = getValues("status");
    }
    if (getValues("roleSeq") !== "") {
      reqBody.roleSeq = getValues("roleSeq");
    }
    axios_querySubAccData(reqBody, true);
  };

  useEffect(() => {
    if (JSON.stringify(currentStatus) !== "{}") {
      setValue("status", currentStatus?.status);
      setValue("roleSeq", currentStatus?.roleSeq);
    }

    let reqBody = { keyword: getValues("keyword") };
    if (getValues("status") !== "") {
      reqBody.status = getValues("status");
    }
    if (getValues("roleSeq") !== "") {
      reqBody.roleSeq = getValues("roleSeq");
    }

    axios_querySubAccData(reqBody);
  }, [currentStatus]);

  const axios_initSubAccData = () => {
    //取得畫面初始資料
    initSubAccData().then((res) => {
      if (checkDpSuccess(res)) {
        setStatusList(res.data.RespBody?.status?.options);
        setRoleList(res.data.RespBody?.role?.options);
      }
    });
  };

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F2010206Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule]
  );

  useEffect(() => {
    axios_getCreateBefore(); //統一檢核
    // axios_getRoleList();//取得角色清單
    // axios_querySubAccData();
    setValue("roleSeq", currentStatus?.roleSeq);
    setValue("status", currentStatus?.status);
    axios_initSubAccData(); //初始化資料
  }, []);

  const btnInviteReadMore = () => {
    let reqBody = {
      inviteSeq: inviteSeq,
    };
    handleInviteSideBar(reqBody, true);
  };

  const customHeader = (
    <div className="flex align-items-center gap-2">
      <span className="font-bold">{t("button.inviteRecord")}</span>
    </div>
  );

  const masKAccountTemplate = (rowData, props) => {
    if (rowData) {
      return <>{!maskView ? getMaskedString("account", rowData?.[props?.field]) : rowData?.[props?.field]}</>;
    }
  };

  const axios_updateAuditEyesEvent = () => {
    updateAuditEyesEvent({
      functionId: chsFuncId,
      eventType: "V",
    }).then((res) => {
      if (checkDpSuccess(res)) {
      }
    });
  };

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          {/* 上方區塊 */}
          <form className="grid" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-12 lg:col-4">
              <label htmlFor="role" className="form-label">
                {t("role")}
              </label>
              <Controller
                name="roleSeq"
                control={control}
                // rules={{ required: { value: true, message: t('validation.required') } }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    appendTo={"self"}
                    optionLabel="value"
                    optionValue="label"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs_all")}
                    name="roleSeq"
                    control={control}
                    options={roleList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            <div className="col-12 lg:col-4">
              <label htmlFor="status" className="form-label">
                {t("status")}
              </label>
              <Controller
                name="status"
                control={control}
                // rules={{ required: { value: true, message: t('validation.required') } }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    appendTo={"self"}
                    optionLabel="value"
                    optionValue="label"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs_all")}
                    name="status"
                    control={control}
                    options={statusList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
            </div>
            <div className="col-12 lg:col-4">
              <FormInput
                register={register}
                errors={errors}
                id="keyword"
                name="keyword"
                type="text"
                labelText={t("keyword")}
                labelClass="control-label"
              />
            </div>
            <div className="col-12 gap-2 flex-all-center">
              <Button type="submit" label={t("button.query")} />
              {getCompanyType() === "M" && (
                <Button
                  outlined
                  type="button"
                  label={t("button.add")}
                  disabled={!isEditable}
                  onClick={() => {
                    handleAddSubAcct();
                  }}
                />
              )}
              {getCompanyType() !== "M" && (
                <Button
                  outlined
                  type="button"
                  label={t("button.invite")}
                  disabled={!isEditable}
                  onClick={() => {
                    if (!createButtonFlag) {
                      setLimitDialog(true);
                    } else {
                      handleInviteSubAcct();
                    }
                  }}
                />
              )}
              {getCompanyType() !== "M" && (
                <Button
                  outlined
                  type="button"
                  label={t("button.inviteRecord")}
                  onClick={() => {
                    handleInviteSideBar();
                  }}
                />
              )}
            </div>
          </form>
        </div>
      </div>
      {/* 下方 Table */}
      <div className="" style={{ top: "28px" }}>
        <Button
          type="button"
          icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
          severity="secondary"
          disabled={rowData?.length === 0}
          onClick={() => {
            setMaskView((prev) => {
              if (!prev) {
                axios_updateAuditEyesEvent();
              }
              return !prev;
            });
          }}
        />
      </div>

      <div className="p-card">
        <div className="p-card-body">
          <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: "55rem" }}
            rows={rowsPerPage}
            value={rowData}
            emptyMessage={<NoInfo panel="table" />}
            footer={
              rowData?.length > 0 && (
                <PrimeTableFooter rowDataList={rowData} isShowMore={true} btnReadMore={btnReadMore} />
              )
            }
          >
            <Column body={orderNoTemplate} header={t("seqNo")} />
            <Column field="acct" body={masKAccountTemplate} sortable header={t("account")} />
            <Column field="roleName" sortable header={t("role")} />
            <Column field="status" sortable header={t("status")} />
            <Column style={{ width: "auto" }} body={actionBodyTemplate} header={t("action")} />
          </DataTable>
        </div>
      </div>

      {/* 新增 Dialog */}
      <PrimeDialog
        scrollByBody={false}
        visible={addDialog}
        onClose={() => {
          setAddDialog(false);
          setValue("acct", "");
          setValue("userName", "");
          // setValue("phone","");
          setValue("add_roleSeq", "");
          clearErrors();
          setConfirmLoad(false);
        }}
        loading={confirmLoad}
        disabledConfirm={!isValid}
        onConfirm={() => {
          confirmAddSubAcct();
        }}
        title={t("button.add")}
        size="md"
        bodyTemplate={
          <>
            <AddSubAcct register={register} errors={errors} roleList={roleList} control={control} />
          </>
        }
      />

      {/* 邀請 Dialog */}
      <PrimeDialog
        scrollByBody={false}
        visible={inviteDialog}
        onClose={() => {
          setInviteDialog(false);
          setValue("userEmail", "");
          setValue("userName", "");
          // setValue("phone","");
          clearErrors();
          setConfirmLoad(false);
        }}
        loading={confirmLoad}
        disabledConfirm={!isValid}
        onConfirm={() => {
          confirmInviteSubAcct();
        }}
        title={t("button.invite")}
        size="md"
        bodyTemplate={
          <>
            <InviteSubAcct register={register} errors={errors} setValidForm={setValidForm} />
          </>
        }
      />

      <Sidebar
        header={customHeader}
        visible={inviteSidebar}
        closeOnEscape={false}
        position="left"
        onHide={() => setInviteSidebar(false)}
        style={{ minWidth: "40vw" }}
        className="w-full md:w-40rem lg:w-30rem"
      >
        <DataTable
          stripedRows
          className="white-data-table hover-highlight no-shadow"
          tableStyle={{ minWidth: "25rem" }}
          value={recordList}
          footer={
            recordList?.length > 0 && (
              <PrimeTableFooter rowDataList={recordList} isShowMore={true} btnReadMore={btnInviteReadMore} />
            )
          }
          emptyMessage={t("no_rec")}
        >
          <Column field="userName" header={t("user_name")} style={{ minWidth: "120px" }} />
          <Column field="userEmail" header={t("user_email")} />
          <Column
            field="createDateTime"
            header={t("create_date")}
            style={{ minWidth: "110px" }}
            body={createDateBodyTemplate}
          />
        </DataTable>
      </Sidebar>

      {/* 子帳戶數量上限 */}
      <PrimeDialog
        visible={limitDialog}
        isShowConfBtn={false}
        onClose={() => {
          setLimitDialog(false);
        }}
        title={t("button.create")}
        bodyTemplate={<>{t("subAccountLimitReached")}</>}
      />
    </>
  );
};
export default SubAccountIndex;
